import { Editor } from '@tiptap/core';
import EditorCache from '../editorcache';
import { serializer } from '../wikitext';

export const setEditor = (editorid: string, editor: Editor) => {
   EditorCache.set(editorid, editor);
};

export const getEditor = (editorid: string): Editor => {
   return EditorCache.get(editorid);
};

const getOrThrowEditor = (editorid: string): Editor => {
   const editor = getEditor(editorid);
   if (!editor) {
      throw new Error(`Editor not found: ${editorid}`);
   }
   return editor;
};

export const getSerializedText = (editorid: string): string => {
   const editor = getOrThrowEditor(editorid);
   return serializer.serialize(editor.state.doc);
};

export const getText = (editorid: string): string => {
   const editor = getOrThrowEditor(editorid);
   return editor.getText();
};

export const focusEditor = (editorid: string) => {
   const editor = getOrThrowEditor(editorid);
   editor.commands.focus();
};

export const resetContent = (editorid: string) => {
   const editor = getOrThrowEditor(editorid);
   editor.commands.setContent(editor.storage.originalState.savedContent.toJSON());
};

export const saveState = (editorid: string) => {
   const editor = getOrThrowEditor(editorid);
   editor.storage.originalState.savedContent = editor.state.doc;
};

export const clearSessionStorage = (editorid: string) => {
   const editor = getEditor(editorid);
   editor?.commands?.clearSessionStorage();
};

export const getCharacterCount = (editorid: string) => {
   const editor = getOrThrowEditor(editorid);
   return editor.storage.characterCount.characters();
};

export const clearError = (editorid: string) => {
   const editor = getOrThrowEditor(editorid);
   editor.commands.clearError();
};
